var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ]
    },
    [
      _c(
        "el-dialog",
        {
          staticClass: "package-box",
          staticStyle: { "padding-top": "0" },
          attrs: { visible: _vm.showDialog, "before-close": _vm.onCloseDialog }
        },
        [
          _c("div", { staticClass: "work-title" }, [
            _c("h3", { staticStyle: { margin: "0" } }, [
              _vm._v("工单：" + _vm._s(_vm.workId))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "header-box" }, [_vm._v("拆包信息")]),
          _vm._v(" "),
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "工单原运单号：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.work.back_express_no,
                      callback: function($$v) {
                        _vm.$set(_vm.work, "back_express_no", $$v)
                      },
                      expression: "work.back_express_no"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "商品名称:" } }, [
                _vm._v("\n        " + _vm._s(_vm.work.goods_name) + "\n      ")
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "商品图片：" } }, [
                _c("div", { staticStyle: { width: "50px", height: "50px" } }, [
                  _c("img", {
                    staticStyle: { height: "100%", width: "100%" },
                    attrs: { src: _vm.work.main_img },
                    on: {
                      click: function($event) {
                        return _vm.imgClick(_vm.work.middle_img)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { label: "用户上传图片：" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "50px", height: "50px" } },
                    [
                      _c("img", {
                        directives: [{ name: "viewer", rawName: "v-viewer" }],
                        staticStyle: { height: "100%", width: "100%" },
                        attrs: { src: _vm.work.picture }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "颜色/尺码/数量：" } }, [
                _c("div", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.work.co_val +
                          "/" +
                          _vm.work.si_val +
                          "/" +
                          _vm.work.goods_number
                      ) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "问题类型:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { size: "small" },
                      on: { change: _vm.problemChange },
                      model: {
                        value: _vm.model.id,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "id", $$v)
                        },
                        expression: "model.id"
                      }
                    },
                    [
                      _c("el-option", { attrs: { value: 0, label: "全部" } }),
                      _vm._v(" "),
                      _vm._l(_vm.problem, function(item) {
                        return _c("el-option", {
                          key: item.problem_id,
                          attrs: {
                            value: item.problem_id,
                            label: item.problem_name
                          }
                        })
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.model.sub_id,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "sub_id", $$v)
                        },
                        expression: "model.sub_id"
                      }
                    },
                    [
                      _c("el-option", { attrs: { value: 0, label: "全部" } }),
                      _vm._v(" "),
                      _vm._l(_vm.subPorblem, function(item) {
                        return _c("el-option", {
                          key: item.problem_id,
                          attrs: {
                            value: item.problem_id,
                            label: item.problem_name
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "登记类型：" } },
                [
                  _vm.blp_type.length > 0
                    ? _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", size: "mini" },
                          model: {
                            value: _vm.registrationType,
                            callback: function($$v) {
                              _vm.registrationType = $$v
                            },
                            expression: "registrationType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "正常", value: "0" }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.blp_type, function(item) {
                            return _c("el-option", {
                              key: item.key,
                              attrs: { label: item.label, value: item.key }
                            })
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "el-icon-plus",
                    staticStyle: {
                      "margin-left": "10px",
                      height: "40px",
                      width: "40px",
                      cursor: "pointer"
                    },
                    on: { click: _vm.addBlp }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "80%" },
                      attrs: { data: _vm.registrationData }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "blp_type_index", label: "类型" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", { staticClass: "blp-text" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getBlpText(scope.row.blp_type)
                                      ) +
                                      "\n              "
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "num", label: "数量", width: "150" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input-number", {
                                  attrs: {
                                    min: _vm.min,
                                    max: Number(_vm.work.num),
                                    size: "mini"
                                  },
                                  model: {
                                    value: scope.row.num,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "num", $$v)
                                    },
                                    expression: "scope.row.num"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "blp_note",
                          label: "备注",
                          width: "150"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "请输入内容"
                                  },
                                  model: {
                                    value: scope.row.blp_note,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "blp_note", $$v)
                                    },
                                    expression: "scope.row.blp_note"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "blp-img-up", label: "图片" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                !scope.row.blp_img
                                  ? _c(
                                      "div",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.setIndex(scope.$index)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "“upload”",
                                            attrs: {
                                              action: _vm.action,
                                              "on-success": _vm.handleSuccess,
                                              "with-credentials": ""
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-picture",
                                              staticStyle: {
                                                "font-size": "20px"
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.blp_img
                                  ? _c("img", {
                                      directives: [
                                        { name: "viewer", rawName: "v-viewer" }
                                      ],
                                      staticClass: "avatar",
                                      staticStyle: {
                                        width: "30px",
                                        height: "30px"
                                      },
                                      attrs: { src: scope.row.blp_img }
                                    })
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "删除" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", { staticClass: "blp-op" }, [
                                  _c("i", {
                                    staticClass: "el-icon-delete",
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "font-size": "20px"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteItem(scope.$index)
                                      }
                                    }
                                  })
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticClass: "header-box" }, [
                _vm._v("\n        已拆商品"),
                _c("span", {
                  staticStyle: { "font-size": "14px", color: "red" }
                })
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "80%", margin: "0 auto" },
                  attrs: { data: _vm.dbids }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "", label: "类型" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "blp-text" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getBlpText(scope.row.blp_type_value)
                                  ) +
                                  "\n            "
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "", label: "打标id" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "blp-text" }, [
                              _vm._v(_vm._s(scope.row.dbid))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "", label: "状态" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "blp-text" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.da_biao_record_status) +
                                  "\n            "
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "", label: "备注" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "blp-text" }, [
                              _vm._v(_vm._s(scope.row.blp_note))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticClass: "header-box" }, [
                _vm._v("\n        无实物拆包"),
                _c("span", {
                  staticStyle: { "font-size": "14px", color: "red" }
                })
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "120px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "输入件数：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: { placeholder: "输入件数", size: "mini" },
                        model: {
                          value: _vm.form.no_back_num,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "no_back_num", $$v)
                          },
                          expression: "form.no_back_num"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "拆包备注：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "textarea",
                          placeholder: "输入拆包备注",
                          size: "mini"
                        },
                        model: {
                          value: _vm.form.back_remark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "back_remark", $$v)
                          },
                          expression: "form.back_remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.onCloseDialog } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitData } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showImg
        ? _c("preview-image", {
            attrs: { imgs: _vm.imgs, show: _vm.showImg },
            on: { closeBox: _vm.closeImg }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-446e1a18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-446e1a18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claims/components/UnPackage.vue
// module id = null
// module chunks = 